import { css } from "@emotion/react";
import { EditModal } from "@src/components";
import { useSugangUsers } from "@src/hooks/queries/useCampus";
import React, { Fragment, useEffect, useRef } from "react";

interface Props {
    open: boolean;
    onCloseView: () => void;
    no: string;
}

const CampusSugangUserModal: React.FC<Props> = ({ open, onCloseView, no }) => {
    const tableRootRef = useRef<any>(null);
    const scrollRef = useRef<any>(null);
    const { data, fetchNextPage, hasNextPage } = useSugangUsers(no);

    const handleObserver = (entries: any[]) => {
        const target = entries[0];
        if (target.isIntersecting && hasNextPage) {
            fetchNextPage();
        }
    };
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                const option = {
                    root: tableRootRef.current,
                    rootMargin: "0px",
                    threshold: 0.5,
                };
                const observer = new IntersectionObserver(
                    handleObserver,
                    option,
                );
                if (scrollRef.current && !hasNextPage) {
                    observer.disconnect();
                    return;
                }
                if (scrollRef.current) {
                    observer.observe(scrollRef.current);
                }
            }, 500);
        }
    }, [handleObserver, open]);

    return (
        <>
            <EditModal
                buttonText="닫기"
                handleBtnClick={onCloseView}
                handleOpenModal={onCloseView}
                size="fitContent"
                title="수강생 리스트"
                isModalShow={open}
            >
                <div css={rootStyle}>
                    <div css={titleRootStyle}>
                        <p>
                            총 : <span>{data?.pages[0].totalCnt}명</span>
                        </p>
                        <p>
                            수강중 : <span>{data?.pages[0].activeCnt}명</span>
                        </p>
                        <p>
                            수강완료 :{" "}
                            <span>{data?.pages[0].inactiveCnt}명</span>
                        </p>
                        <p>
                            환불 : <span>{data?.pages[0].refundCnt}명</span>
                        </p>
                    </div>
                    <div css={tableRootStyle} ref={tableRootRef}>
                        <table>
                            <colgroup>
                                <col width="8%" />
                                <col width="8%" />
                                <col width="12%" />
                                <col width="18%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="20%" />
                                <col width="10%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>수강번호</th>
                                    <th>이름</th>
                                    <th>연락처</th>
                                    <th>이메일</th>
                                    <th>생년월일</th>
                                    <th>총 재생시간</th>
                                    <th>수강기한</th>
                                    <th>수강상태</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.pages.map((group, i) => (
                                    <Fragment key={i.toString()}>
                                        {group.list.length ? (
                                            group.list.map((d: any) => (
                                                <tr key={d.no}>
                                                    <td>{d.no}</td>
                                                    <td>{d.name}</td>
                                                    <td>{d.phone}</td>
                                                    <td>{d.email}</td>
                                                    <td>
                                                        {d.birth.slice(0, 4)}.
                                                        {d.birth.slice(4, 6)}.
                                                        {d.birth.slice(6, 8)}
                                                    </td>
                                                    <td>{d.totalViewTime}</td>
                                                    <td>
                                                        {d.expiredAtToString}
                                                    </td>
                                                    <td>
                                                        <div
                                                            css={{
                                                                padding:
                                                                    ".5rem 1rem",
                                                                borderRadius:
                                                                    "20px",
                                                                backgroundColor:
                                                                    d.statusToString ===
                                                                    "정상"
                                                                        ? "#2979FF"
                                                                        : d.statusToString ===
                                                                          "수강완료"
                                                                        ? "#424242"
                                                                        : "#FF1744",
                                                                color: "#ffffff",
                                                            }}
                                                        >
                                                            {d.statusToString}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={8}
                                                    css={noDataStyle}
                                                >
                                                    <div>
                                                        수강생이 없습니다.🥲
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </Fragment>
                                ))}
                            </tbody>
                        </table>
                        <div ref={scrollRef} css={scrollStyle} />
                    </div>
                </div>
            </EditModal>
        </>
    );
};

export default CampusSugangUserModal;

const titleRootStyle = css`
    display: flex;
    align-items: center;
    p {
        font-size: 1rem;
        color: #424242;
        font-weight: 600;
        margin-right: 1rem;
        span {
            font-weight: 500;
            color: #333333;
        }
    }
`;

const tableRootStyle = css`
    width: 80vw;
    max-width: 1200px;
    margin-top: 2rem;
    height: 500px;
    overflow: scroll;
    max-height: fit-content;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
        display: none;
    }
    table {
        width: 100%;
        thead {
            border-top: 1px solid #b5b5b5;
            border-bottom: 1px solid #b5b5b5;
            background-color: #eeeeee;
            position: sticky;
            top: 0px;
        }
        th {
            padding: 1.2rem;
            span {
                color: #ff0000;
            }
        }
        tbody {
            border-bottom: 1px solid #b5b5b5;
        }
        td {
            padding: 15px 10px;
            text-align: center;
            border-bottom: 1px solid #b5b5b5;
        }
    }
`;

const scrollStyle = css`
    height: 3rem;
`;

const rootStyle = css`
    background-color: #ffffff;
`;

const noDataStyle = css`
    padding: 10rem 0 !important;
`;
